import { BaseFeature, FeatureType } from '@core/shared/feature';
export class TrackingBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@common/tracking/feature","featureId":"common-tracking"},
      bundledItemModels: ["TrackingLogEntityItem"],
      // list is auto-generated by generate-model-ids
      abilityActions: false,
      plugins: [{
        forPlatform: 'frontend',
        type: FeatureType.Permanent,
        pluginClassName: 'TrackingFrontendFeature'
      }, {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'TrackingFrontendAdminFeature'
      }, {
        forPlatform: 'backend',
        type: FeatureType.Permanent,
        pluginClassName: 'TrackingBackendFeature'
      }, {
        forPlatform: 'backend-admin',
        type: FeatureType.Permanent,
        pluginClassName: 'TrackingBackendAdminFeature'
      }]
    };
  }
  getSharedDefinition() {
    return {};
  }
}